var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          ref: "MultiInputTag",
          staticClass: "vue-input-tag-wrapper",
          class: {
            "read-only": _vm.readOnly,
            "vue-input-tag-wrapper--active": _vm.isInputActive,
            "is-disable": _vm.disabled,
          },
          attrs: { id: _vm.id },
          on: {
            click: function ($event) {
              return _vm.focusNewTag()
            },
          },
        },
        [
          _vm.innerTags.length > 0
            ? _c(
                "div",
                {
                  ref: "tagsBox",
                  staticClass: "input-tags-box",
                  style: _vm.inputTagsbox(),
                },
                _vm._l(_vm.innerTags, function (tag, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      ref: "tags",
                      refInFor: true,
                      staticClass: "input-tag",
                      class: { "select-tag": _vm.checkedTagIndex == index },
                      on: {
                        mousedown: function ($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.handleCheckTag(tag, index)
                        },
                        dblclick: _vm.dblclick,
                      },
                    },
                    [
                      _vm.showSearchType
                        ? _c("span", { staticClass: "views_tag" }, [
                            _c("span", [_vm._v(_vm._s(tag.type) + " | ")]),
                            _vm._v(_vm._s(tag.value)),
                          ])
                        : _c("span", { staticClass: "views_tag" }, [
                            _vm._v(_vm._s(tag)),
                          ]),
                      !_vm.readOnly
                        ? _c(
                            "a",
                            {
                              staticClass: "remove",
                              on: {
                                mousedown: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.remove(index)
                                },
                              },
                            },
                            [_c("i", { staticClass: "el-icon-close newIcon" })]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newTag,
                expression: "newTag",
              },
            ],
            ref: "inputtag",
            staticClass: "new-tag",
            class: _vm.isInputActive ? "inputAct" : "inputInact",
            attrs: {
              readonly: _vm.readOnly,
              disabled: _vm.disabled,
              placeholder: _vm.innerTags.length ? "" : _vm.placeholder,
              type: "text",
              maxlength: 100,
            },
            domProps: { value: _vm.newTag },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.newTag = $event.target.value
                },
                _vm.handleInput,
              ],
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                      "Backspace",
                      "Delete",
                      "Del",
                    ])
                  )
                    return null
                  $event.stopPropagation()
                  return _vm.removeLastTag.apply(null, arguments)
                },
                _vm.addNew,
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "left", 37, $event.key, [
                      "Left",
                      "ArrowLeft",
                    ])
                  )
                    return null
                  if ("button" in $event && $event.button !== 0) return null
                  return _vm.handleLeft.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "right", 39, $event.key, [
                      "Right",
                      "ArrowRight",
                    ])
                  )
                    return null
                  if ("button" in $event && $event.button !== 2) return null
                  return _vm.handleRight.apply(null, arguments)
                },
              ],
              blur: _vm.handleInputBlur,
              focus: _vm.handleInputFocus,
            },
          }),
          !_vm.isInputActive && _vm.isShowText
            ? _c("span", { ref: "textBtn", staticClass: "text-btn" }, [
                _vm._v(
                  _vm._s(`${_vm.innerTags.length}`) +
                    _vm._s(_vm.$i18.language("个项目"))
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { ref: "operationBtn", staticClass: "inputtag-operation-btn" },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-end",
                    offset: 30,
                    width: "245",
                    "visible-arrow": false,
                    "popper-options": _vm.popperOptions,
                    trigger: "hover",
                  },
                },
                [
                  _c("div", { staticClass: "precise-query-box" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "sub-confirm-btn",
                            class: {
                              "active-precise-query": !_vm.preciseQuery,
                            },
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleChange()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("search.fuzzyQuery")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "sub-confirm-btn",
                            class: { "active-precise-query": _vm.preciseQuery },
                            attrs: { size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleChange()
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("search.preciseQuery")))]
                        ),
                      ],
                      1
                    ),
                    _vm.id == "trade-search-buyerNames" ||
                    _vm.id == "trade-search-supplierNames" ||
                    _vm.id == "trade-detail-search-buyerNames" ||
                    _vm.id == "trade-detail-search-supplierNames"
                      ? _c("div", { staticClass: "precise-query-content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$i18.language(
                                "使用「精准查询」时，系统将按照完整的词组进行搜索，例如：「NIKE INC」的搜索结果中，将不再包含「NIKE USA INC」"
                              )
                            )
                          ),
                        ])
                      : _c("div", { staticClass: "precise-query-content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$i18.language(
                                "如果您切换为「精准查询」方式，系统将按照完整词组进行精准搜索，例如：「paper machine」的搜索结果中，将不再包含 「paper cup machine」"
                              )
                            )
                          ),
                        ]),
                  ]),
                  _c("svg-icon", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showPreciseQuery,
                        expression: "showPreciseQuery",
                      },
                    ],
                    staticClass: "newIcon",
                    attrs: {
                      slot: "reference",
                      name: _vm.preciseQuery
                        ? "precise-query-active-icon"
                        : "precise-query-icon",
                    },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.handleChange()
                      },
                    },
                    slot: "reference",
                  }),
                ],
                1
              ),
              _vm.showMoreButton && _vm.showSearchType
                ? _c("svg-icon", {
                    staticClass: "newIcon",
                    attrs: { name: "add-more-card" },
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.handleOpenSet.apply(null, arguments)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-popover",
        {
          class: [
            "popover",
            _vm.notAbsolute ? "notAbsolute" : "",
            _vm.optionsList.length <= 0 ? "displayNone" : "",
          ],
          attrs: {
            disabled: _vm.optionsList.length <= 0 || !_vm.isSelect,
            trigger: "click",
            width: _vm.inputWidth,
          },
          on: { "after-leave": _vm.onHide },
          model: {
            value: _vm.optionsVisible,
            callback: function ($$v) {
              _vm.optionsVisible = $$v
            },
            expression: "optionsVisible",
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-scrollbar",
                { attrs: { "wrap-class": "el-autocomplete-suggestion__wrap" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: _vm.scrollLoad,
                          expression: "scrollLoad",
                        },
                      ],
                      staticClass: "compare-month-box",
                    },
                    _vm._l(
                      _vm.optionsList.slice(0, _vm.showLength),
                      function (item) {
                        return _c(
                          "p",
                          {
                            key: item.value,
                            staticClass: "compare-month-item",
                            class: {
                              "active-compare-month-item": _vm.innerTags.some(
                                (e) => e.value == item.value
                              ),
                            },
                            on: {
                              mousedown: function ($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.changeInnerTags(item)
                              },
                            },
                          },
                          [
                            item.value === item.text
                              ? _c(
                                  "span",
                                  { staticClass: "style_module_item_text" },
                                  [_vm._v(_vm._s(item.value))]
                                )
                              : _c("span", { staticClass: "space-between" }, [
                                  _c("span", { staticClass: "text_value" }, [
                                    _vm._v(_vm._s(item.value)),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "text_desc",
                                      attrs: { title: item.text },
                                    },
                                    [_vm._v(_vm._s(item.text))]
                                  ),
                                ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("input-more", {
        ref: "inputMore",
        attrs: {
          limitInputType: "1",
          params: _vm.params,
          showPreciseQuery: _vm.showPreciseQuery,
          preciseQuery: _vm.preciseQuery,
        },
        on: { changeData: _vm.changeData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }